import { html, property, query } from 'lit-element';
import { KatLitElement, event, EventEmitter } from '../../../shared/base';
import styles from './expander.lit.scss';

export class HeadlessExpander extends KatLitElement {
  static styles = [styles];

  /** Whether the content is displayed or not. */
  @property()
  open?: boolean;

  /** The icon to display when the expander is open. Defaults to `expand_less`. */
  @property({ attribute: false })
  iconOpen = 'expand_less';

  /** The icon to display when the expander is closed. Defaults to `expand_more`. */
  @property({ attribute: false })
  iconClose = 'expand_more';

  /** Fired when the expander changes state. */
  @event('toggle', { bubbles: true, cancelable: true })
  private _toggle: EventEmitter<{ open: boolean }>;

  @query('.control')
  private _control: HTMLButtonElement;

  focus() {
    this._control?.focus();
  }

  toggle(open?: boolean) {
    if (open == null) {
      open = !this.open;
    }
    if (this.open !== open) {
      if (this._toggle.emit({ open })) {
        this.open = open;
      }
    }
  }

  private _handleToggle() {
    this.toggle();
  }

  render() {
    return html`
      <button
        class="control"
        type="button"
        aria-controls="content"
        aria-expanded=${this.open ? 'true' : 'false'}
        @click=${this._handleToggle}
      >
        <div class="label">
          <slot name="label"></slot>
        </div>
        <kat-icon
          class="icon"
          size="small"
          name=${this.open ? this.iconOpen : this.iconClose}
        ></kat-icon>
      </button>
      <section id="content">
        <slot></slot>
      </section>
    `;
  }
}
